export const BASE_URL = "https://cms-server-80fv.onrender.com";
// export const BASE_URL = "http://localhost:4000/";
